import { set, unset, compose } from 'lodash/fp'
import {
  UPDATE_SUITABILITY_QUESTIONAIRE,
  UPDATE_SUITABILITY_SCORE,
  UPDATE_SUITABILITY_ANSWER,
  UPDATE_SUITABILITY_STATUS,
  CLEAR_SUITABILITY_ANSWERS,
} from './actions'
import VALUES from '../../../core/data-model/constants/values'
import { RESET_QUOTE_FORM, RESET_APPLICATION_STATE } from '../../actions'

export const initialSuitabilityState = {
  suitabilityQuestionaire: [],
  suitabilityAnswers: [],
  suitabilityScore: {},
  suitabilityStatus: null,
}

const reducer = (state = initialSuitabilityState, action) => {
  switch (action.type) {
    case RESET_QUOTE_FORM:
    case RESET_APPLICATION_STATE:
      return initialSuitabilityState
    case UPDATE_SUITABILITY_QUESTIONAIRE:
      return {
        ...state,
        suitabilityQuestionaire: action.payload,
      }
    case UPDATE_SUITABILITY_ANSWER: {
      const existing = state.suitabilityAnswers || []
      const index = existing.findIndex((a) => a.questionCode === action.payload.questionCode)
      const suitabilityAnswers =
        index >= 0 ? existing.map((item, i) => (i === index ? action.payload : item)) : [...existing, action.payload]
      return {
        ...state,
        suitabilityAnswers,
      }
    }
    case UPDATE_SUITABILITY_SCORE:
      return {
        ...state,
        suitabilityScore: action.payload,
      }
    case UPDATE_SUITABILITY_STATUS:
      return {
        ...state,
        suitabilityStatus: action.payload,
      }
    case CLEAR_SUITABILITY_ANSWERS:
      return {
        ...state,
        suitabilityAnswers: [],
      }
  }
  return state
}

export default reducer
